import moment from 'moment';

import LINK from 'constants/link.const';
import { AP_STATUS } from 'constants/payment/appointmentStatus.const';
import { asNewArray } from 'utils/arrays/array.util';
import { firstOf } from 'utils/arrays/elements.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import call from 'utils/functions/call.util';
import linkTo from 'utils/links/linkTo.util';
import navFor from 'utils/links/navFor.util';
import logger from 'utils/logger.util';

const L = logger('navigateToCheckout'); // eslint-disable-line no-unused-vars

const ALLOWED_STATUSES = Object.freeze([
  AP_STATUS.customerUnverified,
  AP_STATUS.unconfirmed,
  AP_STATUS.confirmed,
  AP_STATUS.arrived,
]);

const navigateToCheckout = (options) => {
  const FTAG = '()';
  const tag = fromAnyToTrimmed(options?.tag);

  try {
    const {
      appointment,
      appointmentId: appointmentIdFromOptions,
      history,
      isDay,
      isWeek,
      nav,
      onData,
      onClean,
      pdi,
      procedures,
      salonId,
      stylistId,
    } = options ?? {};

    if (!appointment) {
      L.warn(FTAG, tag, 'Missing appointment:', appointment, 'in options:', options);
      return false;
    }

    const appointmentId = appointment.id ?? appointmentIdFromOptions;
    if (!appointmentId) {
      L.warn(FTAG, tag, 'Missing appointmentId and appointment.id in options:', options);
      return false;
    }

    const extendedProceduresSalonId = appointment.salon_id ?? salonId;
    const extendedProcedures = asNewArray(appointment.procedures).map((procedure) => {
      // NOTE: fix for BE endpoint sending the client id named as pk
      const c = appointment.client ?? {};
      const client = { ...c, id: c.id ?? c.pk };

      return {
        ...(procedure ?? {}),
        appointment: {
          id: appointmentId,
          client,
          status: appointment.status,
          salon_id: extendedProceduresSalonId,
          salonId: extendedProceduresSalonId,
        },
      };
    });

    const firstAppointmentProcedure = firstOf(appointment.procedures);
    const startTime = firstAppointmentProcedure?.start_time ?? firstAppointmentProcedure?.startTime;
    const startOfDay = moment(startTime).startOf('day').toString();
    const dayPdi = pdi?.[startOfDay];

    if (dayPdi) {
      for (let index = 0; index < dayPdi.length; index += 1) {
        const procedure = procedures?.[dayPdi?.[index]];

        if (procedure?.appointment?.id === appointmentId) continue;
        if (!ALLOWED_STATUSES.includes(procedure?.appointment?.status)) continue;

        extendedProcedures.push(procedure);
      }
    } else {
      L.warn(FTAG, tag, 'Bad procedure day index for', { pdi, startOfDay, startTime, firstAppointmentProcedure });
    }

    const view = isDay ? 'day' : isWeek ? 'week' : '';
    if (!view) L.warn(FTAG, tag, 'Missing either isDay or isWeek to be set to true in options:', options);

    if (!salonId) L.warn(FTAG, tag, 'Invalid salonId:', salonId);
    if (isWeek && !stylistId) L.warn(FTAG, tag, 'Invalid stylistId:', stylistId);

    const fault = '';
    const pathname = isDay
      ? linkTo({ pattern: LINK.checkoutDay, params: { salonId }, fault })
      : isWeek
        ? linkTo({ pattern: LINK.checkoutStartWeek, params: { salonId, stylistId }, fault })
        : fault;

    if (fault === pathname) {
      L.warn(FTAG, tag, 'Bad pathname:', pathname, 'for:', { salonId, stylistId, isDay, isWeek });
      return false;
    }

    call('navigateToCheckout() > onClear()', onClean);
    const firstProcedure = firstOf(extendedProcedures);
    call('navigateToCheckout() > onData()', onData, firstProcedure, salonId, appointmentId, extendedProcedures, view);

    if (history) {
      navFor(FTAG, tag, { history }).push({ pathname });
    } else {
      nav?.push({ pathname });
    }
  } catch (e) {
    L.warn(FTAG, tag, e);
    return false;
  }

  return true;
};

export default navigateToCheckout;
